import React, { useState } from "react";
import { Share2, Check } from "lucide-react";
import axios from "axios";
import "./ShareButton.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ShareButton({ title, imagePath, urlPath, className }) {
  const [state, setState] = useState("idle"); // idle | loading | copied | ready

  const handleShare = async () => {
    if (state !== "idle") return;
    setState("loading");
    try {
      const fullImage = imagePath.startsWith("http") ? imagePath : `${window.location.origin}${imagePath}`;
      const fullUrl = `${window.location.origin}${urlPath}`;
      
      const res = await axios.post(`${API}/share`, {
        title,
        image: fullImage,
        url: fullUrl
      });
      
      const shareUrl = `${window.location.origin}/api/share/${res.data.id}`;
      await navigator.clipboard.writeText(shareUrl);
      
      setState("copied");
      setTimeout(() => setState("ready"), 1200);
      setTimeout(() => setState("idle"), 3000);
    } catch (e) {
      console.error("Failed to generate share link", e);
      setState("idle");
    }
  };

  return (
    <button 
      className={`${className} share-btn-status share-${state}`} 
      onClick={handleShare} 
      aria-label="Share" 
    >
      <div className="share-icon-wrap">
        {state === "idle" || state === "loading" ? <Share2 size={18} /> : <Check size={18} />}
      </div>
      <div className="share-text-wrap">
        {state === "loading" && <span className="share-txt">Hamsters spinning up a URL...</span>}
        {state === "copied" && <span className="share-txt">Copied to your clipboard!</span>}
        {state === "ready" && <span className="share-txt">Ready to paste</span>}
      </div>
    </button>
  );
}
